import * as yup from 'yup';

import { validatePhoneNumber } from './phoneValidation';
import { TRANSLATIONS as text } from '../../translations';

const { addressForm } = text;
const { formErrors, formValidations } = addressForm;

export default yup.object().shape({
  hasPhone: yup.boolean(),
  phone: yup.string().when(['hasPhone', 'country'], {
    is: (hasPhone, country) => hasPhone && country !== 'US',
    then: (schema) =>
      schema
        .required(formErrors.phone)
        .test('is-valid-phone', formValidations.phone, function (value) {
          if (!value) {
            return false;
          }
          const country = this.parent?.country;
          return validatePhoneNumber(value, country || null);
        }),
    otherwise: (schema) => schema,
  }),
});
